import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getInventoryList = createAsyncThunk(
  "get-inventory",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("inventory/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInventoryList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getInventoryList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.inventoryList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getInventoryList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default inventorySlice.reducer;
